<template>
    <html>
    <body style="position: relative;background: #fff">
        <section class="section">
            <img src="@/assets/styles/images-link/ban6.png" alt="">
        </section>
        <section class="section container03">
            <div class="da">
            <div class="zuo">
                <h2>平台介绍</h2>
                <h4>Platform Introduction</h4>
                <p>平台采用行政区域地理树的结构方式，结合软硬件设备，帮助执法监管人员实现现场办公、现场取证、任务打卡、法规查询等操作；实现合成化作战、集约化管理、智能化监督的市、县级一体化监管体系，保持数据、监管、执法高度同步全面服务于每一位执法监管人员。 </p>
            </div>
            <img src="@/assets/styles/images-link/zh1.png" alt=""> </div>
        </section>
        <section class="section container03 background1">
            <div class="da">
            <div class="zuo">
                <h2 style="color: #fff">总体目标</h2>
                <h4 style="color: #fff">Overall objective</h4>
                <p style="color: #fff">建立农业执法智慧化、移动化系统；建立应用支撑体系；建立市、县、乡镇三级数据互联互通的监管体系；建立农产品及农资市场流通的规范化监管体系；优化数据资源；建立农业执法平台统一对外门户。 </p>
            </div>
            <img src="@/assets/styles/images-link/zh5.png" alt="" style="margin-top: 40px">
            <div class="zuo" style="margin-top: 40px">
                <h2 style="color: #fff">服务用户</h2>
                <h4 style="color: #fff">Service user</h4>
            </div>
            <ul>
                <li> <img src="@/assets/styles/images-link/zh2.png" alt="" >
                <div>
                    <h2 >执法办案人员</h2>
                    <p>共享数据：执法表单数据、法律法规数据、证据采集数据。 </p>
                    <p>互动流程：案件的互通。</p>
                </div>
                </li>
                <li> <img src="@/assets/styles/images-link/zh3.png" alt="" >
                <div>
                    <h2>农业执法监督管理人员</h2>
                    <p>下发执法任务、监督案件进程、执法人员考核、远程指挥调度。 </p>
                </div>
                </li>
            </ul>
            </div>
        </section>
        <section class="section container11">
            <div class="da" style="width: 1200px!important">
            <div class="zuo">
                <h2>业务流程</h2>
                <h4>Business Process</h4>
            </div>
            <img src="@/assets/styles/images-link/zh4.png" alt="" style="width: 70%;margin: auto;display: block;margin-top: 20px;margin-bottom: 20px">
            <div class="zuo" >
                <h2>系统特点</h2>
                <h4>System Features</h4>
            </div>
            <div class="pai" style="margin-top: 20px">
                <div class="x"> <img src="@/assets/styles/images-link/td1.png" alt="">
                <p>平台全面升级</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td2.png" alt="">
                <p>移动执法</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td3.png" alt="">
                <p>PC客户端应用</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td4.png" alt="">
                <p>农资数据库</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td5.png" alt="">
                <p>数据互联互通</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td6.png" alt="">
                <p>大数据技术</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td7.png" alt="">
                <p>数据可视化</p>
                </div>
                <div class="x"> <img src="@/assets/styles/images-link/td8.png" alt="">
                <p>辅助决策</p>
                </div>
            </div>
            </div>
        </section>
        <section class="section container03 background2">
            <div class="da">
            <div class="zuo">
                <h2 style="color: #39bf3e">工作数据查询</h2>
                <h4>Statistical Analysis</h4>
                <p style="font-size: 16px;line-height:30px;color: #333">通过与相关农业法规系统对接，生成农业大数据专题数据库包含法律法规、违法行为、农资数据等12类专题数据库，为执法人员提供全面的执法数据宝典。</p>
            </div>
            <img src="@/assets/styles/images-link/zh6.png" alt="" style="width: 90%"> </div>
        </section>
        <section class="section container03">
            <div class="da">
            <div class="zuo">
                <h2>执法应急指挥管理</h2>
                <h4>Law enforcement emergency command management</h4>
                <p>系统通过图像传输、视频监控、语音对讲、地图定位、轨迹跟踪等功能与4G执法记录仪进行远程互动互通，实现执法过程全方位监管。 </p>
            </div>
            <img src="@/assets/styles/images-link/zh7.png" alt="" style="margin-top: 20px"> </div>
        </section>
        <section class="section container12 background3" style="">
            <div class="da">
            <div class="zuo">
                <h2>硬件介绍</h2>
                <h4>Hardware introduction</h4>
            </div>
            <ul>
                <li style="width: 60%;"> <img src="@/assets/styles/images-link/zh8.png" alt=""  style="width: 80%;">
                <p>4g音频执法记录仪</p>
                </li>
                <li style="width: 40%;"> <img src="@/assets/styles/images-link/zh9.png" alt="" style="width: 40%;">
                <p>数据执法记录仪采集站</p>
                </li>
            </ul>
            </div>
        </section>
    </body>
</html>
</template>

<style scoped>
    .background1{
        width: 100%;
        background: url('~@/assets/styles/images-link/bg8.png') no-repeat center;
        background-size: 100%
    }
    .background2{
        background: url('~@/assets/styles/images-link/bg9.png') center no-repeat;
        background-size: 100%
    }
    .background3{
        padding: 1% 0;width: 100%;
        background: url('~@/assets/styles/images-link/bg10.png') no-repeat center;
        background-size: 100%;
    }
    .container03 .da ul {
            width: 100%;
            margin: auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .container03 .da ul li {
            width: 48%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            border-width: 1px;
            border-color: rgb(0, 228, 255);
            border-style: solid;
            border-radius: 100px;
            background-color: #fff;
            box-shadow: 0px 1px 10px 0px rgba(10, 16, 40, 0.59);padding: 10px 0;
        }
        .container03 .da ul li img {
            width: 134px;
            margin-right: 20px
        }
        .container03 .da ul li img:hover {
            transform: rotate(360deg);
            transition: all ease-out 0.4s
        }
        .container03 .da ul li div {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start
        }
        .container03 .da ul li div h2 {
            font-size: 24px;
            color: #39bf3e;
            margin-bottom: 10px
        }
        .container03 .da ul li div p {
            font-size: 16px;
            color: #000
        }
        .container03 .da ul li div p span {
            color: #0293fe
        }

           .container11 .da .pai {
            width: 1200px;
            margin: auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
        .container11 .da .pai div {
            width: 10%;
            margin: 0 1%;
            text-align: center
        }
        .container11 .da .pai div img {
            width: 100%;display: block;
            margin-bottom: 10px;
        }
        .container11 .da .pai div img:hover {
            transform: scale(1.2);
            transition: all ease-out 0.4s
        }
        .container11 .da .pai div p {
            font-size: 16px;
            color: #333
        }
            
            
</style>
<script>

    import '@/assets/styles/css/zhihui1.css';   
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农业综合执法智慧监管系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
